import {connect} from 'react-redux';
import AccreditationGroupsList from "./AccreditationGroupsList";
import {getTranslation} from "../../../reducers/common/localization";
import {
    fetchGetAccreditationGroups, getAccreditationGroupsData,
    loadingAccreditationGroups
} from "../../../reducers/organization/accreditationGroups";
import {
    MODAL_ADD_ACCREDITATION_GROUP, MODAL_REMOVE_ACCREDITATION_GROUP,
    showModal
} from "../../../reducers/common/activeModal";
import {setAccreditationGroupId, getAccreditationGroupId} from "../../../reducers/organization/accreditationGroup";
import {resetSubmitForm} from '../../../reducers/common/submitForm';

const mapStateToProps = state => {
    return {
        groupId: getAccreditationGroupId(state),
        translation: getTranslation(state),
        loading: loadingAccreditationGroups(state),
        data: getAccreditationGroupsData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(setAccreditationGroupId(null));
            dispatch(fetchGetAccreditationGroups());
        },
        onAddButtonClick: () => {
            dispatch(showModal({modalKey: MODAL_ADD_ACCREDITATION_GROUP}));
            dispatch(resetSubmitForm());
        },
        onAccreditationGroupSelect: (id) => dispatch(setAccreditationGroupId(id)),
        onAccreditationGroupRemove: () => {
            dispatch(showModal({modalKey: MODAL_REMOVE_ACCREDITATION_GROUP}));
            dispatch(resetSubmitForm());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccreditationGroupsList);



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/AccreditationGroupsList/AccreditationGroupsList.container.js